// import appAndPages from './app-and-pages'
// import chartsAndMaps from './charts-and-maps'
import panel from './panel'
import recruitment from './recruitment'
import immigration from './immigration'
import staff from './staff'
import sale from './sale'
import logistics from './logistics'
import communication from './communication'
import settings from './settings'

// Array of sections
export default [...panel, ...recruitment, ...immigration, ...staff, ...sale, ...logistics, ...communication, ...settings]
